import { Conferencistas } from '../components/Conferences';

import { Objetivo } from '../components/Objetive';
import { Programa } from '../components/Programs';
import { Slider } from '../components/Slider';
import { Speakers } from '../components/Speakers';
import { base } from '../data/base';

export const Home = () => {
  return (
    <>
      <Slider />
      <Objetivo goal={base.goal} />
      <Conferencistas speakers={base.mainSpeakers} />
      <Speakers speakers={base.speakers} />
      <Programa img={base.programa} />
    </>
  );
};
